module.exports = __webpack_public_path__ + "img/accruedAdmin.c57876fd.svg";